<script setup lang="ts">

import { DealerLocation } from "@app/Components/DealerLocation";
import { useAppConfiguration } from "@domain/AppConfiguration";

const app = useAppConfiguration();

</script>

<template>

    <div class="w-full h-full overflow-y-auto flex flex-col pb-12 tracking-wider">
             
         <div class="bg-gradient-to-b dark:from-gray-900 via-80% dark:via-gray-850 dark:to-gray-850">
                
            <div class="p-6 text-center">
                <h2 class="text-xl tracking-wider flex gap-2 justify-center items-center">
                    Home Dealership
                </h2>
                <p class="text-sm lg:text-base pt-4 opacity-60">
                    This is your home dealership, your first stop for service, maintenance and repairs
                </p>    
            </div>   

            <!-- HEADER BRANDING -->
            <div>
                <div class="overflow-hidden w-full flex flex-col items-center
                            pb-6 3xl:pb-8">
                    <div class="text-xl 3xl:text-3xl font-bold">
                        {{app.name}}
                    </div>
                    <!-- <RouterLink class="flex items-center !p-0 !min-w-0 mt-2 cursor-pointer"
                                to="/my-garage/dealership/change">
                        <span class="text-xs 3xl:text-sm uppercase text-primary-500 dark:text-secondary-400 tracking-normal">
                            Change
                        </span>
                    </RouterLink> -->
                </div>
            </div>
        </div>

        <div class="flex flex-col px-4 lg:px-6 gap-4 lg:gap-6 3xl:gap-8
                    bg-gradient-to-b dark:from-gray-850 dark:to-gray-900">
            <DealerLocation :title="app.serviceLocation.name" type="service" />
            <DealerLocation :title="app.dealerLocation.name" type="dealership" />
        </div>
        
    </div>

</template>